import { vs } from "react-syntax-highlighter/dist/esm/styles/hljs";

export const markdownStyles = {
  ...vs,
  keyword: {
    color: "#0000FF",
    fontWeight: "bold",
    textDecoration: "underline",
  }, // Синий, жирный и подчеркнутый для ключевых слов
  built_in: { color: "#0000FF", fontWeight: "bold" }, // Синий и жирный для встроенных функций
  string: { color: "#008000" }, // Зеленый для строк
  comment: { color: "#808080", fontStyle: "italic" }, // Серый и курсив для комментариев
  function: { color: "#AA6600", fontWeight: "bold" }, // Оранжевый и жирный для функций
  class: { color: "#800080", fontWeight: "bold" }, // Фиолетовый для классов
  number: { color: "#0000FF" }, // Синий для чисел
  operator: { color: "#000000", fontWeight: "bold" }, // Черный и жирный для операторов
  punctuation: { color: "#000000" }, // Черный для пунктуации
  variable: { color: "#CC0000" }, // Красный для переменных
  import: {
    color: "#0000FF",
    fontWeight: "bold",
    backgroundColor: "transparent",
  }, // Синий и жирный для импортов, без фона
};

export const cellBaseStyles = {
  py: 1,
  px: 2,
  border: "1px solid #E0E0E0",
  borderRadius: "4px",
  position: "relative",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.03)",
  },

  "& p": {
    my: 0.5,
    wordBreak: "break-word",
  },
  "& h1, & h2, & h3, & h4, & h5, & h6": {
    mt: 1,
    mb: 0.5,
  },
  "& ul, & ol": {
    mt: 0.5,
    mb: 0.5,
    pl: 3,
  },
  "& li": {
    mb: 0.25,
  },
  "& code": {
    backgroundColor: "#f5f5f5",
    px: 0.5,
    borderRadius: 0.5,
    fontFamily: "monospace",
    fontSize: "0.9em",
  },
  "& pre": {
    backgroundColor: "transparent",
    p: 0,
    borderRadius: 0,
    overflowX: "auto",
    my: 0.5,
  },
  "& blockquote": {
    borderLeft: "3px solid #e0e0e0",
    pl: 1,
    ml: 1,
    my: 0.5,
    color: "text.secondary",
  },
  "& img": {
    maxWidth: "100%",
  },
  "& table": {
    borderCollapse: "collapse",
    width: "100%",
    my: 1,
  },
  "& th, & td": {
    border: "1px solid #e0e0e0",
    p: 0.5,
  },
};
